module.exports = __webpack_public_path__ + "img/bf6243e.png";